import './index.css';
import './config/icons'; // Register FontAwesome icons before any components render
import App from './App';
import { ThemeProvider } from 'styled-components';
import theme from './theme';
import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <ThemeProvider theme={theme}>
        <App />
    </ThemeProvider>
);
